import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { IonSearchbar, ModalController } from '@ionic/angular';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { GuestCheckoutPage } from '../guest-checkout/guest-checkout.page';
import { ToastService } from 'src/app/services/toast.service';
import { isBefore } from 'date-fns'
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'app-ticket-lookup',
  templateUrl: './ticket-lookup.page.html',
  styleUrls: ['./ticket-lookup.page.scss'],
})
export class TicketLookupPage  {
  @ViewChild('searchInput') searchInput:IonSearchbar;
  hasEmail=false
  searchText = ''
  firstDate=new Date()
  loadingResult
  width = window.innerWidth;
  ticketResult:any={};
  hiddenEmail;
  loginResult;
  verifyLoading=false
  isFalsey=false
  emailForm:FormGroup= new FormGroup({})
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private toastSRV:ToastService,
    private fb: FormBuilder,
    private router: Router,
    public platformSRV:PlatformService,
    public dataSRV:DataService,
    private modalCtrl: ModalController) { 

      this.emailForm = this.fb.group({
        "email": "",
        "ticket":""
        
      })
    }
    clearErrors(){
      this.isFalsey=false
    }
    emailLogin(){
      this.loginResult={}
      this.verifyLoading=true
      this.isFalsey=false
      this.dataSRV.postData('violations/login',this.emailForm.value).subscribe({
        next:data=>{
          if(data['status']=='error'){
         
          
            this.emailForm.controls['email'].setErrors({'incorrect': true});
            this.isFalsey=true
          } 
          
          else if(data['status']=='success'){
            this.dataSRV.fromViolations=true
            this.router.navigateByUrl('/account/password')
            this.isFalsey=false
          }
         
           
          
         
          this.verifyLoading=false
          this.loginResult=data
        },
        error:err=>{
          this.isFalsey=true
          this.errorHandlerSRV.displayErrorMessage(err,true)
        }
        
        
      }
      
      )
    }
  ionViewWillEnter() {
    this.dataSRV.csrfToken=null
    if(!this.dataSRV.csrfToken){
      this.dataSRV.getData('get-token').subscribe(data=>{
     
        this.dataSRV.csrfToken=data['state'].csrf_token
        console.log(this.dataSRV.csrfToken);
        setTimeout(() => {
          this.searchInput.setFocus()
        }, 250);
        
      })
    } else {
      this.searchInput.setFocus()
    }
   
  }
  async checkoutTicket(){
    const desktopModal = await this.modalCtrl.create({
      component: GuestCheckoutPage,
      breakpoints: [0.5, 0.8,1],
     
      cssClass: 'modal-desktop-long',
      componentProps:{
        violation: this.ticketResult
      }
     
    });
    const mobileModal = await this.modalCtrl.create({
      component: GuestCheckoutPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal",
      componentProps:{
        violation: this.ticketResult
      }
     
    })
    const tabletModal = await this.modalCtrl.create({
      component: GuestCheckoutPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1, 
      cssClass:"modal-tablet-normal",
      componentProps:{
        violation: this.ticketResult
      }
     
    })
    var modal = await this.dataSRV.getModalType(mobileModal, tabletModal, desktopModal)
    modal.onDidDismiss().then(response=>{
      this.searchTicket()
    })
    modal.present()
    
    
    
    
  }
  goToLogin(){
    this.modalCtrl.dismiss()
  }
  goToCreateAccount(){
    this.modalCtrl.dismiss().then(()=>{
      this.router.navigate(['register']); 
    })
  }
  closeModal() {
    this.modalCtrl.dismiss();
  }
  resetSearch(){
    this.ticketResult={}
  }
  searchTicket(){
    if(this.searchText.trim().length>0){
      this.clearErrors()
      this.ticketResult={}
      this.loadingResult=true
      this.dataSRV.postData('api/violations/lookup',{ "ticket":this.searchText}).subscribe({
        next:(data:any)=>{
          if(data?.status=='success'){
            if(data['violation']?.['Due']){
              if(isBefore(this.firstDate,new Date(data['violation']['Due']))){
                this.hasEmail=true
              } else {
                this.hasEmail=false
              }
            }
            
            this.ticketResult=data
           
            
            this.emailForm.controls['ticket'].setValue(this.searchText.trim())
            
            this.loadingResult=false
          } else {
            this.loadingResult=false
            this.errorHandlerSRV.displayErrorMessage(data,true)
          }
        },error:error=>{
          if (error?.error_code==2024) {
            this.ticketResult=error
          } else {
            this.errorHandlerSRV.displayErrorMessage(error,true)
          }
          this.loadingResult=false
         
        }

      })
    } else{
      this.ticketResult={}
    }
    
  }

}
